import React, { useEffect } from 'react';
import { Adsense } from '@ctrl/react-adsense';

const loadAdsenseScript = () => {
    const script = document.createElement('script');
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3940256099942544";
    script.async = true;
    document.body.appendChild(script);
};

const TestAd = () => {
    /*
    loadAdsenseScript()
  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);
  */
  return (
    <div>
      {/* Responsive Ad */}
      <Adsense 
        client="ca-pub-5159154835077533"
        slot="4904509831"
        style={{ display: 'block' }}
        layout="in-article"
        format="fluid" 
      /> 
    </div>
  );
}

export default TestAd;
